import { render, staticRenderFns } from "./OzListRow.vue?vue&type=template&id=b55b11d6&"
import script from "./OzListRow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzListRow.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports